import { useState, useMemo } from 'react';

export default function useFilters(tareas) {
  const [filtros, setFiltros] = useState({
    prioridad: '',
    responsableId: '',
    loteId: '',
    busqueda: '',
  });

  const tareasFiltradas = useMemo(() => {
    return tareas.filter(tarea => {
      if (filtros.prioridad && tarea.prioridad !== filtros.prioridad) return false;
      if (filtros.responsableId && tarea.responsable_id !== filtros.responsableId) return false;
      if (filtros.loteId && tarea.lote_id !== filtros.loteId) return false;
      if (filtros.busqueda && !tarea.titulo.toLowerCase().includes(filtros.busqueda.toLowerCase())) return false;
      return true;
    });
  }, [tareas, filtros]);

  const getTareasPorEstado = (estado) => {
    return tareasFiltradas.filter(t => t.estado === estado);
  };

  const resetFiltros = () => {
    setFiltros({
      prioridad: '',
      responsableId: '',
      loteId: '',
      busqueda: '',
    });
  };

  return {
    filtros,
    setFiltros,
    tareasFiltradas,
    getTareasPorEstado,
    resetFiltros,
  };
}
